
const LocationsSuccessFactor = Object.freeze({
  muscle_shoals: "Muscle Shoals (MUS)"
})

export default LocationsSuccessFactor



//   'Baltimore (BAL)': 'Baltimore',
//   'Bowling Green (BOW)': 'Bowling Green',
//   'Burnham (BUH)': 'Burnham',
//   'Burg (BUR)': 'Burg',
//   'Changchun (CHA)': 'Changchun',
//   'Le Valais': 'Le Valais',
//   'Crailsheim (CRA)': 'Crailsheim',
//   'Dahenfeld (DAH)': 'Dahenfeld',
//   'Decin (DEC)': 'Decin',
//   'Gottmadingen (GOT)': 'Gottmadingen',
//   'Issoire (IS)': 'Issoire',
//   'Landau (LAN)': 'Landau',
//   'Levice (LEV)': 'Levice',
//   'Montreuil Juigné (MJ)': 'Montreuil Juigné',
//   'Muscle Shoals (MUS)': 'Muscle Shoals',
//   'Nanjing (NAN)': 'Nanjing',
//   'Neuf Brisach (NH)': 'Neuf Brisach',
//   'Nuits Saint Georges (NUI)': 'Nuits Saint Georges',
//   'Paris (PAR)': 'Paris',
//   'Plymouth (PLY)': 'Plymouth',
//   'Ravenswood (RAV)': 'Ravenswood',
//   'Seoul (SEO)': 'Seoul',
//   'Shanghai (SHA)': 'Shanghai',
//   'Singen (SIN)': 'Singen',
//   'San Louis Potosí (SLP)': 'San Louis Potosí',
//   'Tokyo (TOK)': 'Tokyo',
//   'Ussel (USS)': 'Ussel',
//   'Van Buren (VB)': 'Van Buren',
//   'Vigo (VIG)': 'Vigo',
//   'Voreppe (VO)': 'Voreppe',
//   'White (WHI)': 'White',
//   'Zilina (ZIL)': 'Zilina',
//   'Zürich (ZU)': 'Zürich',
//   None: 'None',